import { useField, useFormikContext } from "formik";
import { createDateString, formatFieldsForPreFill } from "./helpers";
import { useEffect } from "react";
import { isValid } from "date-fns";
/** Handle changes to field in on paste action or when initial values exist */
export const useHandlePreFill = (name, dayRef, monthRef, yearRef, setDay, setMonth, setYear, disabled) => {
    const { setFieldValue } = useFormikContext();
    const [field] = useField(name);
    const preFillFields = (value, fieldName) => {
        const { formatedMonth, formatedDay, formatedYear } = formatFieldsForPreFill(value);
        setDay(formatedDay);
        setMonth(formatedMonth);
        setYear(formatedYear);
        dayRef.current.value = formatedDay;
        monthRef.current.value = formatedMonth;
        yearRef.current.value = formatedYear;
        setFieldValue(fieldName, createDateString(formatedMonth, formatedDay, formatedYear));
    };
    useEffect(() => {
        // Fill date with initial values on page load, if they exist.
        preFillFields(field.value, name);
    }, []);
    useEffect(() => {
        // Signing admission will change field value thus update the disabled date field.
        disabled && preFillFields(field.value, name);
    }, [field.value]);
    const onPasteDate = e => {
        const pastedDate = new Date(e.clipboardData.getData("text/plain"));
        // MMDDYYYY format
        if (isValid(pastedDate)) {
            preFillFields(pastedDate, name);
        }
    };
    return {
        /** Controll what happens when date is pasted to field. */
        onPasteDate,
    };
};
